import fetch from '../utils/fetch'

export function saveDistributor(query) {
    if (query.distributor_id) {
        return fetch({
            url: '/distributor/' + query.distributor_id,
            method: 'put',
            data: query
        })
    } else {
        return fetch({
            url: '/distributor',
            method: 'post',
            data: query
        })
    }
}

export function saveIsExpress(query) {
    if (query.distributor_id) {
        return fetch({
            url: '/distributor/' + query.distributor_id,
            method: 'put',
            data: query
        })
    } else {
        return fetch({
            url: '/distributor',
            method: 'post',
            data: query
        })
    }
}

export function getDistributorList(query) {
    return fetch({
        url: '/distributors',
        method: 'get',
        params: query
    })
}

export function getBasicConfig() {
    return fetch({
        url: '/distribution/basic_config',
        method: 'get'
    })
}

export function saveBasicConfig(query) {
    return fetch({
        url: '/distribution/basic_config',
        method: 'post',
        data: query
    })
}

export function getDistributeLogs(query) {
    return fetch({
        url: '/distribution/logs',
        method: 'get',
        params: query
    })
}

export function getCashWithdrawalPayInfo(cash_withdrawal_id) {
    return fetch({
        url: '/distributor/cash_withdrawal/payinfo/' + cash_withdrawal_id,
        method: 'get'
    })
}

export function getCashWithdrawals(query) {
    return fetch({
        url: '/distribution/cash_withdrawals',
        method: 'get',
        params: query
    })
}

export function processCashWithdrawal(id, query) {
    return fetch({
        url: '/distribution/cash_withdrawal/' + id,
        method: 'put',
        params: query
    })
}

export function getDistributorCount(distributorId) {
    return fetch({
        url: '/distributor/count/' + distributorId,
        method: 'get'
    })
}

export function getDistributionCount() {
    return fetch({
        url: '/distribution/count',
        method: 'get'
    })
}

export function saveDistributorItems(query) {
    return fetch({
        url: '/distributor/items',
        method: 'post',
        data: query
    })
}

export function getDistributorItems(query) {
    return fetch({
        url: '/distributor/items',
        method: 'get',
        params: query
    })
}

export function itemcategory(query) {
    return fetch({
        url: '/distributor/get/itemcategory',
        method: 'get',
        params: query
    })
}

export function getWxaDristributorCodeStream(query) {
    return fetch({
        url: '/distributor/wxacode',
        //url: '/distributor/self/wxacode',
        method: 'get',
        params: query
    })
}

export function mulitOpenClose (query) {
  return fetch({
    url: '/distributor/mulitOpenClose',
    method: 'post',
    data: query
  })
}

// export function delDistributorItems(query) {
//     return fetch({
//         url: '/distributor/item',
//         method: 'delete',
//         params: query
//     })
// }

export function updateDistributorItem(query) {
    return fetch({
        url: '/distributors/item',
        method: 'put',
        params: query
    })
}

export function syncDistributorItemStock (query) {
  return fetch({
    url: '/distribution/items/upstockfromoms',
    method: 'put',
    params: query
  })
}

export function updateDistributorItemCatrgory(query) {
    return fetch({
        url: '/distributor/update/itemcategoryedit',
        method: 'post',
        data: query
    })
}

export function setDefaultDistributor(query) {
    return fetch({
        url: '/distributor/default',
        method: 'post',
        data: query
    })
}

export function getSalesmanList(query) {
    return fetch({
        url: '/distributor/salesmans',
        method: 'get',
        params: query
    })
}

export function updateSalesman(salesmanId, query) {
    return fetch({
        url: '/distributor/salesman/' + salesmanId,
        method: 'put',
        data: query
    })
}

export function addSalesman(query) {
    return fetch({
        url: '/distributor/salesman',
        method: 'post',
        data: query
    })
}

export function getDistributorInfo(query) {
    return fetch({
        url: '/distributors/info',
        method: 'get',
        params: query
    })
}

export function saveTag(params) {
    return fetch({
        url: '/distributor/tag',
        method: 'post',
        data: params
    })
}

export function getTagList(query) {
    return fetch({
        url: '/distributor/tag',
        method: 'get',
        params: query
    })
}

export function getTagInfo(tagId) {
    return fetch({
        url: '/distributor/tag/' + tagId,
        method: 'get'
    })
}

export function updateTag(tagId, params) {
    return fetch({
        url: '/distributor/tag/' + tagId,
        method: 'put',
        data: params
    })
}

export function deleteTag(tagId) {
    return fetch({
        url: '/distributor/tag/' + tagId,
        method: 'delete'
    })
}

export function distributorRelTags(query) {
    return fetch({
        url: '/distributor/reltag/',
        method: 'post',
        data: query
    })
}

// 怡康店铺类型设置
export function getShopTypes(query) {
    return fetch({
        url: '/shoptypes',
        method: 'get',
        data: query
    })
}

// 商品批量同步到店铺
export function addStore(query) {
    return fetch({
        url: '/goods/distributors/batchsetItemsStore',
        method: 'post',
        data: query
    })
}

// 批量发布商品
export function addItemsToDistributors(query) {
    return fetch({
        url: '/distributor/items/addItemsToDistributors',
        method: 'post',
        data: query
    })
}


//获取 经营品类下所有商品
export function getStoreDistributorItems(query) {
    return fetch({
        url: '/distributor/items/store',
        method: 'get',
        params: query
    })
}

// 发布到店铺new
export function addStoreDistributorItemsNew(query) {
    return fetch({
        url: '/distributor/items/storeaddnew',
        method: 'post',
        data: query
    })
}

export function getShopTypeInfo(query) {
    return fetch({
        url: '/shoptypes/info',
        method: 'get',
        params: query
    })
}

export function saveShopType(query) {
    if (query.shop_type_id) {
        return fetch({
            url: '/shoptype/' + query.shop_type_id,
            method: 'put',
            data: query
        })
    } else {
        return fetch({
            url: '/shoptype',
            method: 'post',
            data: query
        })
    }
}

export function delShopType(query) {
    return fetch({
        url: '/shoptype/' + query.shop_type_id,
        method: 'delete',
        data: query
    })
}

export function editDistributorItemsCategory(query) {
    return fetch({
        url: '/distributor/relitemscategory',
        method: 'post',
        data: query
    })
}

export function getDistributorItemsCategory(query) {
    console.log(query)
    return fetch({
        url: '/distributor/getrelitemscategory',
        method: 'get',
        params: query
    })
}

export function getOfficeArea(query) {
    return fetch({
        url: '/setting/areamanage/list',
        method: 'get',
        params: query
    })
}

//店铺公告
export function getNoticeList(query) {
    return fetch({
        url: '/distributor/notice',
        method: 'get',
        params: query
    })
}

export function addNotice(query) {
    return fetch({
        url: '/distributor/notice',
        method: 'post',
        data: query
    })
}

export function updateNotice(distributor_notice_id, params) {
    return fetch({
        url: '/distributor/notice/' + distributor_notice_id,
        method: 'put',
        data: params
    })
}

export function delNotice(distributor_notice_id) {
    return fetch({
        url: '/distributor/notice/' + distributor_notice_id,
        method: 'delete',
    })
}

export function getQRcode(query) {
    return fetch({
        url: '/distributor/getDistributorQR',
        method: 'get',
        params: query
    })
}

export function addDistributorAlterAd(query) {
    return fetch({
        url: '/distributor/alterAd',
        method: 'post',
        data: query
    })
}

export function getDistributorAlterList(query) {
    return fetch({
        url: '/distributor/alterAdList',
        method: 'get',
        params: query
    })
}

export function delDistributorAlterAd(query) {
    return fetch({
        url: '/distributor/alterAd/' + query,
        method: 'delete',
        data: query
    })
}

export function editDistributorAlterAdRelDis(query) {
    return fetch({
        url: '/distributor/alterAd/reldistributor',
        method: 'post',
        data: query
    })
}

export function delDistributorItems(query) {
    return fetch({
        url: '/distributor/delDistributorItems',
        method: 'post',
        data: query
    })
}

export function getDistributorselfActivity(query) {
    return fetch({
        url: '/distributor/get/selfActivity',
        method: 'get',
        params: query
    })
}

export function saveDistributorselfActivity(query) {
    return fetch({
        url: '/distributor/save/selfActivity',
        method: 'post',
        params: query
    })
}
// 更新店铺活动状态
export function changeDistributorselfStatue(query) {
    return fetch({
        url: '/distributor/changeStatus/selfActivity',
        method: 'post',
        params: query
    })

}

export function getDistributorselfActivityDetail(activity_id) {
    return fetch({
        url: '/distributor/get/selfActivity/' + activity_id,
        method: 'get',
        params: activity_id
    })
}

export function getDistributorselfActivityLog(query) {
    return fetch({
        url: '/distributor/get/selfActivitylog',
        method: 'get',
        params: query
    })
}

export function exportDistributorActivityLog(query) {
    return fetch({
        url: '/distributor/export/selfActivitylog',
        method: 'post',
        params: query
    })
}
//抽奖活动相关
export function getActivityLog(query) {
    return fetch({
        url: '/promotions/ActivityLog',
        method: 'get',
        params: query
    })
}
export function exportActivityLog(query) {
    return fetch({
        url: '/promotions/export/Activitylog',
        method: 'get',
        params: query
    })
}
export function getActivityCategoryList (query) {
    return fetch({
        url: '/promotions/lotteryActivitys',
        method: 'get',
        params: query
    })
}

// 重新发送中奖信息
export function resendActivityMsg (query) {
    return fetch({
        url: '/promotions/resendActivityMsg',
        method: 'post',
        data: query
    })
}
//导出活动基础信息
export function exportDistributorActivityDetail(query) {
    return fetch({
            url: '/distributor/export/selfActivityDetail',
            method: 'post',
            params: query
    })
}

// 店铺分类活动列表
export function getDistributorActivityCategoryList (query) {
    return fetch({
        url: '/distributor/selfActivity/getCategoryList',
        method: 'post',
        params: query
    })
}

//删除店铺活动
export function delDistributorLog(id) {
    return fetch({
        url: '/distributor/selfActivity/delete/'+ id,
        method: 'delete'
    })
}

// 增加店铺分类
export function addDistributorActivityCategory (query) {
    return fetch({
        url: '/distributor/selfActivity/addCategory',
        method: 'post',
        params: query
    })
}

// 女子医院活动专项数据
export function nzyyActivityLog(query) {
    return fetch({
        url: '/discountcard/nzyyLog',
        method: 'post',
        params: query
    })
}

// 女子医院活动专项数据导出
export function nzyyActivityLogExport(query) {
    return fetch({
        url: '/discountcard/nzyyLog/export',
        method: 'post',
        params: query
    })
}

// 获取店铺自定义商品分类
export function getCustomCategory(query) {
    return fetch({
        url: '/distributor/goods/custom/category',
        method: 'get',
        params: query
    })
}

/**********店铺打印机设备管理************/
// 获取设备列表
export function getPrintDeviceList(query) {
    return fetch({
        url: '/distribution/print_device/getlist',
        method: 'get',
        params: query
    })
}

// 蓝牙打印设备解绑
export function unbindPrintDevice(distributor_id) {
    return fetch({
        url: '/distribution/print_device/unbind/' + distributor_id,
        method: 'put',
        data: distributor_id
    })
}

export function updateOperatingTime (query) {
    return fetch({
        url: '/distributor/operating/time',
        method: 'put',
        data: query
    })
}

export function updateScope (query) {
  return fetch({
    url: '/distribution/scope/update',
    method: 'put',
    data: query
  })
}
export function exportDistributorInfo(query) {
    return fetch({
        url: '/distributor/export/info',
        method: 'get',
        params: query
    })
}



// WEBPACK FOOTER //
// ./src/api/marketing.js